import { render, staticRenderFns } from "./scrollable-content.vue?vue&type=template&id=0920e8ca&scoped=true"
import script from "./scrollable-content.vue?vue&type=script&lang=js"
export * from "./scrollable-content.vue?vue&type=script&lang=js"
import style0 from "./scrollable-content.vue?vue&type=style&index=0&id=0920e8ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0920e8ca",
  null
  
)

export default component.exports